const autoFocus = {
  mounted(el) {
    // 首次显示
    setTimeout(() => {
      el.getElementsByTagName('input')[0].focus();
    }, 0);
  },
  updated(el, binding) {
    // 后续显示
    if (binding.value && !binding.oldValue) {
      setTimeout(() => {
        el.getElementsByTagName('input')[0].focus();
      }, 0);
    }
  },
  install(Vue) {
    Vue.directive('tc-auto-focus', autoFocus);
  }
};
export default autoFocus;